import React from 'react';
import { Circle as BulletActive, ExpandMoreRounded as ExpandIcon, FeedOutlined as DocumentIcon } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const documentsItemsConfig = [
  {
    permission: 1,
    label: 'Creation of Request',
    to: '/request',
  },
  {
    permission: 29,
    label: 'Creation of MC Request',
    to: '/request/managers_cheque',
  },
  {
    permission: 21,
    label: 'Creation of Counter Receipt',
    to: '/counter-receipt/creating',
  },
  {
    permission: 20,
    label: 'Tagging of Documents',
    to: '/document/tagging',
    notificationKey: 'Tagging of Document',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 53,
    label: 'Monitoring of Document Tagging',
    to: '/document/monitor/tagging',
    notificationKey: 'Tagging of Document',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 25,
    label: 'Transmittal Of Official Receipt',
    to: '/document/transmitting',
    notificationKey: 'Transmittal of Official Receipt',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 27,
    label: 'Transmittal Of GAS Documents',
    to: '/document/transmitting-gas-document',
    notificationKey: 'Transmittal of GAS Voucher',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 35,
    label: 'Monitoring of Official Receipt Transmittal',
    to: '/document/monitor/official-receipt',
    notificationKey: 'Transmittal of Official Receipt',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 33,
    label: 'Transmittal for Filing of Voucher',
    to: '/document/transmitting-file-voucher',
    notificationKey: 'Transmittal for Filing of Voucher',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 19,
    label: 'Transmittal of Voucher',
    to: '/document/voucher-transmitting',
    notificationKey: 'Transmittal of Document',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 23,
    label: 'Transmittal of Cheque',
    to: '/cheque/transmitting',
    notificationKey: 'Transmittal of Cheque',
    notificationArrayProp: 'cheque',
    isLoadingProp: 'isChequeLoading',
    notificationValue: 'pending',
  },
  {
    permission: 22,
    label: 'Monitoring of Counter Receipt',
    to: '/counter-receipt/monitoring',
  },
  {
    permission: 26,
    label: 'Filing Of Official Receipt',
    to: '/document/filing',
    notificationKey: 'Filing of Official Receipt',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'pending',
  },
  {
    permission: 20,
    label: 'Returned/Held Documents',
    to: '/document/returned-documents',
    notificationKey: 'Tagging of Document',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'return',
  },
  {
    permission: 1,
    label: 'Returned Requests',
    to: '/request/returned-requests',
    notificationKey: 'Creation of Request',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
    notificationValue: 'return',
  },
];

const SidebarDocumentsDropdown = ({
  activeDropdown,
  user,
  transactions,
  cheque,
  shouldDisplayDotNotification,
  isTransactionsLoading,
  isChequeLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/document|request/gi));

  const allNotifications = {
    'Creation of Request': transactions,
    'Tagging of Document': transactions,
    'Transmittal of Official Receipt': transactions,
    'Transmittal of Document': transactions,
    'Transmittal of GAS Voucher': transactions,
    'Transmittal for Filing of Voucher': transactions,
    'Transmittal of Cheque': cheque,
    'Filing of Official Receipt': transactions,
  };

  const allLoadingStates = {
    isTransactionsLoading,
    isChequeLoading,
  };

  const hasNotifications = documentsItemsConfig.some(
    (item) => user.permissions.includes(item.permission) && item.notificationKey && shouldDisplayDotNotification(allNotifications[item.notificationKey], item.notificationKey),
  );

  return (
    <Accordion defaultExpanded={/tagging|gas|executive|requestor/i.test(user.role)} elevation={0} square disableGutters>
      <AccordionSummary
        className={isActiveDropdown ? `FstoSidebarActiveDropdown-root ${color}` : `FstoSidebarDropdown-root  ${color}`}
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <DocumentIcon />
        <Typography variant="sidebar">Documents</Typography>
        {!isTransactionsLoading && hasNotifications ? <BulletActive className="FstoSidebarActiveNotif-root" /> : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {documentsItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {item.notificationKey && !allLoadingStates[item.isLoadingProp] && (
                  <DisplayBubbleNotification notificationArray={allNotifications[item.notificationKey]} permission={item.notificationKey} value={item.notificationValue} />
                )}
              </RouterLink>
            ),
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarDocumentsDropdown;
